module.exports = __webpack_public_path__ + "img/ramon-salinero-vEE00Hx5d0Q-unsplash.766c00b7.jpg";